import React from 'react';

const ReportsPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-[#272727]">Reports</h1>
    </div>
  );
};

export default ReportsPage;
